import Vue from 'vue'
import VueRouter from 'vue-router'
import MainLayout from './layouts/MainLayout'
import TokenService from "./services/TokenService";

Vue.use(VueRouter)


const router = new VueRouter({
    mode: 'history',
    linkExactActiveClass: 'active',
    routes: [
        {
            path: '/login',
            component: () => import('./views/Login/Login'),
            name: 'login',
            meta: {
                public: true,
                onlyWhenLoggedOut: true
            },
        },
        {
            path: '/',
            component: MainLayout,
            children: [
                {
                    path: '/',
                    redirect: {name: 'dashboard'}
                },
                {
                    path: '/dashboard',
                    component: () => import('./views/Dashboard/Home'),
                    name: 'dashboard'
                },
                {
                    path: '/courses',
                    component: () => import('./views/Courses/Courses'),
                    name: 'courses'
                },
                {
                    path: '/top-courses',
                    component: () => import('./views/Courses/TopCourses/TopCourses'),
                    name: 'top-courses'
                },
                {
                    path: '/news',
                    component: () => import('./views/News/NewsList'),
                    name: 'news'
                },
                {
                    path: '/course-form/:id',
                    component: () => import('./views/Courses/CourseForm'),
                    name: 'course-form'
                },
                {
                    path: '/course/:id',
                    component: () => import('./views/Courses/Course'),
                    name: 'course'
                },
                {
                    path: '/course-transcription/:id?',
                    component: () => import('./views/Courses/Components/CourseTranscription/Transcription'),
                    name: 'course-transcription'
                },
                {
                    path: '/users-list',
                    component: () => import('./views/Users/UsersList'),
                    name: 'users-list'
                },
                {
                    path: '/abiturient-list',
                    component: () => import('./views/Users/AbiturientList'),
                    name: 'abiturient-list'
                },
                {
                    path: '/badges-list',
                    component: () => import('./views/Badges/BadgesList'),
                    name: 'badges-list'
                },
                {
                    path: '/category-list',
                    component: () => import('./views/Categories/CategoryList'),
                    name: 'category-list'
                },
                {
                    path: '/tests/:id',
                    component: () => import('./views/Tests/TestsList'),
                    name: 'tests'
                },
                {
                    path: '/tests-question/:id?/:type?',
                    component: () => import('./views/Tests/TestsQuestion'),
                    name: 'tests-question'
                },
                {
                    path: '/skills',
                    component: () => import('./views/Skills/Skills'),
                    name: 'skills'
                },
                {
                    path: '/tariff-list',
                    component: () => import('./views/Tariff/TariffList'),
                    name: 'tariff-list'
                },
                {
                    path: '/discount-list',
                    component: () => import('./views/Discount/DiscountList'),
                    name: 'discount-list'
                },
                {
                    path: '/video',
                    component: () => import('./views/video'),
                    name: 'video'
                },
                {
                    path: '/subject',
                    component: () => import('./views/Subject/Subjects'),
                    name: 'subject'
                },
                {
                    path: '/subject-view/:id',
                    component: () => import('./views/Subject/SubjectView'),
                    name: 'subject-view'
                },
                {
                    path: '/profile',
                    component: () => import('./views/Users/Profile/Profile'),
                    name: 'profile'
                },
                {
                    path: '/about-us',
                    component: () => import('./views/AboutUs/Form'),
                    name: 'about-us'
                },
                {
                    path: '/test-component',
                    component: () => import('./plugins/test'),
                    name: 'test-component'
                },
                {
                    path: '/test-specialities',
                    component: () => import('./views/Tests/Specs'),
                    name: 'test-specialities'
                },
                {
                    path: '/test-monitoring',
                    component: () => import('./views/Tests/Monitoring'),
                    name: 'test-monitoring'
                },
                {
                    path: '/test-editing:id?',
                    component: () => import('./views/Tests/Editing/AddEdit'),
                    name: 'test-editing'
                },
                {
                    path: '/test-list',
                    component: () => import('./views/Tests/Editing/TestsList'),
                    name: 'test-list'
                },
                {
                    path: '/create-exam-using-specs',
                    component: () => import('./views/Tests/Exams'),
                    name: 'create-exam-using-specs'
                },
            ]
        },
    ]
});

router.beforeEach((to, from, next) => {
    const isPublic = to.matched.some(record => record.meta.public);
    const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut);
    let hasToken = !!TokenService.getToken();

    if (!isPublic && !hasToken) {
        return next({
            name: 'login'
        })
    }

    if (hasToken && onlyWhenLoggedOut) {
        return next({
            name: 'dashboard'
        })
    }

    next();
});

export default router
